/**
 * Life@Work — twee kleine dingen, zonder bibliotheek.
 *
 * 1. Het menu op mobiel open- en dichtklappen.
 * 2. Secties rustig laten verschijnen zodra ze in beeld komen.
 *
 * Beide vallen netjes terug: zonder JavaScript blijft alles zichtbaar en
 * werkt het menu via de gewone links in de footer.
 */
(function () {
  'use strict';

  /* ---------- menu ---------- */
  function menu(wortel) {
    var knop = (wortel || document).querySelector('.law-header__schakel');
    var paneel = (wortel || document).querySelector('.law-header__paneel');
    if (!knop || !paneel) return;

    knop.addEventListener('click', function () {
      var open = paneel.classList.toggle('is-open');
      knop.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = knop.querySelector('.law-visueel-verborgen');
      if (label) label.textContent = open ? 'Menu sluiten' : 'Menu openen';
    });

    /* Esc sluit het menu en zet de aandacht terug op de knop. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !paneel.classList.contains('is-open')) return;
      paneel.classList.remove('is-open');
      knop.setAttribute('aria-expanded', 'false');
      knop.focus();
    });
  }

  /* ---------- verschijnen ---------- */
  var mag = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  var waarnemer = null;

  if (mag && 'IntersectionObserver' in window) {
    waarnemer = new IntersectionObserver(function (items) {
      items.forEach(function (item) {
        if (!item.isIntersecting) return;
        item.target.classList.add('is-zichtbaar');
        waarnemer.unobserve(item.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function bekijk(wortel) {
    var lijst = (wortel || document).querySelectorAll('.law-reveal:not(.is-zichtbaar)');
    Array.prototype.forEach.call(lijst, function (el) {
      if (waarnemer) {
        waarnemer.observe(el);
      } else {
        el.classList.add('is-zichtbaar');
      }
    });
  }

  function start(wortel) {
    menu(wortel);
    bekijk(wortel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  /* In de editor worden secties opnieuw geladen zonder de pagina te verversen. */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
